import { gql } from '@apollo/client';
import {
  ARTICLE_FIELDS,
  CUSTOMER_ARTICLE_FIELDS,
  DOCUMENT_LINE_FIELDS,
  PAGE_INFO_FIELDS,
} from './fragments';

// ============================================================================
// Article Lookup Queries
// ============================================================================

export const ARTICLE_SEARCH_QUERY = gql`
  query ArticleSearch($query: String!, $limit: Int = 10) {
    articleSearch(query: $query, limit: $limit) {
      ...ArticleFields
    }
  }
  ${ARTICLE_FIELDS}
`;

export const ARTICLE_QUERY = gql`
  query Article($articleNumber: String!) {
    article(articleNumber: $articleNumber) {
      ...ArticleFields
    }
  }
  ${ARTICLE_FIELDS}
`;

export const ARTICLE_BY_BARCODE_QUERY = gql`
  query ArticleByBarcode($barcode: String!) {
    articleByBarcode(barcode: $barcode) {
      ...ArticleFields
    }
  }
  ${ARTICLE_FIELDS}
`;

export const ARTICLES_BY_NUMBERS_QUERY = gql`
  query ArticlesByNumbers($articleNumbers: [String!]!) {
    articlesByNumbers(articleNumbers: $articleNumbers) {
      ...ArticleFields
    }
  }
  ${ARTICLE_FIELDS}
`;

// ============================================================================
// Customer Articles (paginated)
// ============================================================================

export const CUSTOMER_ARTICLES_QUERY = gql`
  query CustomerArticles(
    $search: String
    $documentTypes: [DocumentType!]
    $dateFrom: Date
    $dateTo: Date
    $onlyFavorites: Boolean
    $sortBy: ArticleSortField
    $sortDirection: SortDirection
    $first: Int = 20
    $after: String
    $allCustomers: Boolean
    $customerNumbers: [String!]
  ) {
    customerArticles(
      search: $search
      documentTypes: $documentTypes
      dateFrom: $dateFrom
      dateTo: $dateTo
      onlyFavorites: $onlyFavorites
      sortBy: $sortBy
      sortDirection: $sortDirection
      first: $first
      after: $after
      allCustomers: $allCustomers
      customerNumbers: $customerNumbers
    ) {
      edges {
        node {
          ...CustomerArticleFields
        }
        cursor
      }
      pageInfo {
        ...PageInfoFields
      }
      totalCount
      searchMatches {
        token
        kind
      }
    }
  }
  ${CUSTOMER_ARTICLE_FIELDS}
  ${PAGE_INFO_FIELDS}
`;

// ============================================================================
// Article History (price history per article)
// ============================================================================

export const ARTICLE_HISTORY_QUERY = gql`
  query ArticleHistory(
    $input: ArticleHistoryInput!
    $first: Int = 20
    $after: String
    $allCustomers: Boolean
    $customerNumbers: [String!]
  ) {
    articleHistory(input: $input, first: $first, after: $after, allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      edges {
        node {
          ...DocumentLineFields
          document {
            id
            documentNumber
            documentDate
            type
            customerName
          }
        }
        cursor
      }
      pageInfo {
        ...PageInfoFields
      }
      totalCount
    }
  }
  ${DOCUMENT_LINE_FIELDS}
  ${PAGE_INFO_FIELDS}
`;
